// extracted by mini-css-extract-plugin
export default {"creatureListHeader":"creature-list-header_creatureListHeader__rG+ZX"};